
import { useState } from "react";
import { Database } from "@/integrations/supabase/types";

type TimeOfDay = Database["public"]["Enums"]["time_of_day"];

export interface Guest {
  firstName: string;
  lastName: string;
}

export const useEventForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState<Date | undefined>(new Date());
  const [preferredDates, setPreferredDates] = useState<Date[]>([]);
  const [preferredTimeOfDay, setPreferredTimeOfDay] = useState<TimeOfDay[]>([]);
  const [eventLocation, setEventLocation] = useState("");
  const [locationType] = useState<'specific' | 'flexible'>('specific');
  const [preferredVenues, setPreferredVenues] = useState<string[]>([]);
  const [locationNote, setLocationNote] = useState("");
  const [titleError, setTitleError] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [guestList, setGuestList] = useState<Guest[]>([]);
  const [eventDeadline, setEventDeadline] = useState<Date | null>(null);

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setDate(new Date());
    setPreferredDates([]);
    setPreferredTimeOfDay([]);
    setEventLocation("");
    setPreferredVenues([]);
    setLocationNote("");
    setTitleError("");
    setImageUrl("");
    setImageUrls([]);
    setGuestList([]);
    setEventDeadline(null);
  };

  return {
    title,
    setTitle,
    description,
    setDescription,
    date,
    setDate,
    preferredDates,
    setPreferredDates,
    preferredTimeOfDay,
    setPreferredTimeOfDay,
    eventLocation,
    setEventLocation,
    locationType,
    setLocationType: () => {}, // Keeping the setter but making it a no-op
    preferredVenues,
    setPreferredVenues,
    locationNote,
    setLocationNote,
    titleError,
    setTitleError,
    imageUrl,
    setImageUrl,
    imageUrls,
    setImageUrls,
    guestList,
    setGuestList,
    eventDeadline,
    setEventDeadline,
    resetForm,
  };
};
